import * as React from 'react';
import { FC, useId } from 'react';
import { moneyStr } from 'app/helpers/money';
import type { JackpotView } from './types';
import { useLocales } from './locales';

type JackpotViewComponentProps = { jackpotView: JackpotView; currency: string };

const JackpotViewComponent: FC<JackpotViewComponentProps> = ({ jackpotView, currency }) => {
  const l = useLocales();
  const id = useId();

  return (
    <li className="jw-range_item" aria-labelledby={id}>
      <h3 className="jw-range_title" id={id}>
        {jackpotView.name}
      </h3>
      <div className="jw-range_amount">
        <p>{moneyStr(jackpotView.current_value, currency)}</p>
      </div>
      <div className="jw-range_info">
        <p>
          {`${l('hit_range')}:`} <span>{`${jackpotView.min_hit} – ${jackpotView.max_hit} ${currency}`}</span>
        </p>
      </div>
      <div className="jw-range_bet">
        <p>
          {l('bet_range')}: <span>{`${jackpotView.min_bet} – ${jackpotView.max_bet} ${currency}`}</span>
        </p>
      </div>
      <div className="jw-range_image" />
    </li>
  );
};

const WrappedJackpotView: FC<JackpotViewComponentProps> = (props) => <JackpotViewComponent {...props} />;

export default WrappedJackpotView;
